module.exports = __webpack_public_path__ + "static/media/red-counter.c6cd0126.svg";